import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface IExhibitorMeetingRatingsState extends ISagaCb {}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const exhibitorMeetingRatingsSlice = createSlice({
    name: 'meeting-statistics/exhibitor-meetign-ratings',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IExhibitorMeetingRatingsState>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const exhibitorMeetingRatingsActions = exhibitorMeetingRatingsSlice.actions
export default exhibitorMeetingRatingsSlice.reducer
